import { useTranslation, UseTranslationOptions } from 'react-i18next';
import { Paths, WithoutPrefix, KeyOrString } from '@sib/types';
import type { Namespace, Resource } from './resources';

export type NamespaceKeys<N extends Namespace> =
  | Paths<Resource[N]>
  | Paths<Resource['common']>;

export const createUseAppTranslation =
  <N extends Namespace>(namespace: N) =>
  <P extends string | undefined = undefined>(
    options?: UseTranslationOptions<P>
  ) => {
    const result = useTranslation(namespace, options);

    type AllKeys = NamespaceKeys<N>;
    type Keys = WithoutPrefix<AllKeys, P>;

    return {
      ...result,
      t: result.t as <K extends Keys>(
        key: KeyOrString<K>,
        options?: Parameters<typeof result.t>[1]
      ) => string,
    };
  };

export const useCommonTranslation = createUseAppTranslation('common');
